import React from "react";

const tapeColors = {
    yellow: "bg-tape/85",
    blue: "bg-[#A8C8E0]/80",
    green: "bg-highlight/90",
    red: "bg-marker-red/30",
};

export const MaskingTape = ({
    color = "yellow",
    className = "",
    rotate = "-rotate-3",
    style,
}) => (
    <span
        aria-hidden="true"
        className={`absolute mix-blend-multiply shadow-sm ${tapeColors[color] || tapeColors.yellow} ${rotate} ${className}`}
        style={style}
    />
);

export default MaskingTape;
